import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["Icon-svg"] || "Icon-svg"} viewBox="8 8 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="none" d="M26.786 19.165c.618.354.618 1.316 0 1.67L14.015 28.14c-.522.299-1.265-.064-1.265-.835v-14.61c0-.771.743-1.134 1.265-.835l12.771 7.305z" stroke="currentColor" strokeWidth="1.5" /></svg>);